module.exports = __webpack_public_path__ + "fonts/cb61ac4fca1dd4fbbcb5a2e7b3403d5c.svg";